import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var LayoutDashboard = createReactComponent("LayoutDashboard", ["svg", defaultAttributes, [["rect", {
  x: "3",
  y: "3",
  width: "7",
  height: "9",
  key: "1l9xge"
}], ["rect", {
  x: "14",
  y: "3",
  width: "7",
  height: "5",
  key: "x7ld02"
}], ["rect", {
  x: "14",
  y: "12",
  width: "7",
  height: "9",
  key: "r7q49a"
}], ["rect", {
  x: "3",
  y: "16",
  width: "7",
  height: "5",
  key: "1rj4p1"
}]]]);
export default LayoutDashboard;